module.exports = __webpack_public_path__ + "img/works2.7cb81906.jpg";